<template>
  <div class="layout">
    <router-view />
    <div id="modal" />
  </div>
</template>

<script>
import MeszView from '@/components/MeszView.vue';
import Mes10View from '@/components/Mes10View.vue';
import Mes15View from '@/components/Mes15View.vue';
import MicroCalculator from '@/components/MicroCalculator.vue';
import AspireCalculator from '@/components/AspireCalculator.vue';
import LocatorWrapper from '@/components/LocatorWrapper.vue';
import NutrientRemoval from '@/components/NutrientRemoval.vue';
import CampaignMicroCalculator from '@/components/CampaignMicroCalculator.vue';

export default {
  components: {
    MeszView,
    Mes10View,
    Mes15View,
    MicroCalculator,
    AspireCalculator,
    LocatorWrapper,
    NutrientRemoval,
    CampaignMicroCalculator
  }
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  &__page {
    flex-grow: 1;
    min-height: 1px;
  }

  @media print {
    .print {
      display: block;
      > * {
        display: block;
      }
    }

    .print-hide {
      display: none;

      > * {
        display: none;
      }
    }
  }
}
</style>
